import { FunctionComponent } from 'react';
import { PanelGroup, Panel } from '@cbridge-tools/resizable-panels';
import { useDispatch, useSelector } from '@cbridge-utils/react-redux';
import { SideFilterPanel, ConfigPageLayout, usePersistedPanelLayout, panelLayoutSettingKey } from '@cbridge-modules/layout';
import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { CoreSymbolGroupsFilter } from '@cbridge-modules/symbol-groups-filter';
import { SymbolGroupsAction, selectedSymbolGroupsSelector } from '@cbridge-packages/symbol-groups';
import { SymbolsNavigation } from '../../_navigation/SymbolsNavigation';
import { LpSubNavigation } from './LpSubNavigation/LpSubNavigation';

export const SymbolsLpLayout: FunctionComponent = () => {
  const dispatch = useDispatch();

  const selectedSymbolGroups = useSelector(selectedSymbolGroupsSelector);

  const hasActiveFilters = selectedSymbolGroups?.length > 0;

  const handleClearAllFilters = () => {
    dispatch(SymbolGroupsAction.clearSelect());
  };

  const sideLayoutProps = usePersistedPanelLayout(panelLayoutSettingKey(UserSettingsPage.ConfigSymbolsLp, 'side'));

  return (
    <ConfigPageLayout settingsKey={UserSettingsPage.ConfigSymbolsLp}>
      <SymbolsNavigation />
      <PanelGroup direction={'vertical'} style={{ flex: '1 0 600px' }} {...sideLayoutProps}>
        <Panel
          id={'list'}
          minSize={20}
          defaultSize={60}
        >
          <LpSubNavigation />
        </Panel>
        <SideFilterPanel
          collapsible={true}
          defaultSize={40}
          onClearAllFilters={handleClearAllFilters}
          hasActiveFilters={hasActiveFilters}
        >
          <CoreSymbolGroupsFilter />
        </SideFilterPanel>
      </PanelGroup>
    </ConfigPageLayout>
  );
};
